import { cn } from '@/common/utilities.ts'

type FormErrorMessageProps = {
  message?: string
  className?: string
}
export default function FormErrorMessage({
  message,
  className,
}: FormErrorMessageProps) {
  if (message == undefined || message == '') return null
  return <span className={cn('text-sm text-danger', className)}>{message}</span>
}
